export default __webpack_public_path__ + "static/media/placeholder_business01-it-web.51458ac5.png";